<section>
  <span *ngIf="filterValidateMessage" class="filter-validate-message">{{budgetReportLblText.infoMessageLbl}}</span>
  <form [formGroup]="budgetReportHeaderForm">
    <div class="row budget-report-header-div">
      <div class="form-group budgetReport-header-start-date">
        <label class="lbl" [for]="effectiveFromLBL">{{budgetReportLblText.startDateLbl}}<span class="requiredField">*</span></label>
        <kendo-datepicker formControlName="startDate" class="kendoInput" name="effectiveFrom"
                          placeholder="MM/DD/YYYY"
                          #effectiveFromLBL format="MM/dd/yyyy"
                          [formatPlaceholder]="{year: 'YYYY', month: 'MM', day: 'DD'}">
        </kendo-datepicker>
      </div>
      <div class="form-group budgetReport-header-start-date">
        <label class="lbl" [for]="effectiveToLBL">{{budgetReportLblText.endDateLbl}}<span class="requiredField">*</span></label>
        <kendo-datepicker formControlName="endDate" class="kendoInput" name="effectiveTo"
                          placeholder="MM/DD/YYYY"
                          #effectiveToLBL format="MM/dd/yyyy"
                          [formatPlaceholder]="{year: 'YYYY', month: 'MM', day: 'DD'}">
        </kendo-datepicker>
      </div>
      <!--[disabled]="filterSaveInProcess"-->
      <div class="form-group">
        <button kendoButton class="btn dialogBtnSize filter-date-btn"
                (click)="getFilterbudgetReportHeader()">
          {{budgetReportLblText.filterlbl}}
        </button>
        <!--*ngIf="filterSaveInProcess"-->
      </div>
    </div>
  </form>
</section>
<section>
  <kendo-grid [data]="budgetReportHeaderGridData"
              class="budgetReportSelectionGridCls"
              [sortable]="true"
              [selectable]="false"
              [navigable]="true"
              [filterable]="true"
              [groupable]="false"
              [reorderable]="true"
              [resizable]="true"
              [sort]="budgetReportGridstate.sort"
              [pageable]="{ buttonCount: 5, info: true, pageSizes:[50,75,100] }"
              [pageSize]="budgetReportGridstate.take"
              [skip]="budgetReportGridstate.skip"
              [columnMenu]="{ filter: false, sort: false }"
              (sort)="budgetReportHeaderGridSortChange($event)"
              (pageChange)="budgetReportHeaderGridPageChange($event)"
              (dataStateChange)="budgetReportHeaderGridDataStateChange($event)"
              [filter]="budgetReportGridSettings.state.filter"
              [loading]="budgetReportLoading">
    <!--(columnReorder)="onbudgetReport($event)"
    (columnVisibilityChange)="onVisibilityChange($event)"-->

    <ng-template kendoGridToolbarTemplate>
      <div class="k-grid-toolbar-button-display btn-web">
        <button kendoButton class="excel-button " icon="file-excel" [disabled]="loadingExcel" (click)="generateExcel()">
          {{budgetReportLblText.exportToExcelLbl}}
          <kendo-loader *ngIf="loadingExcel"></kendo-loader>
        </button>
        <button kendoButton icon="file-pdf" class="pdf-button " [disabled]="loadingPDF" (click)="generatePDF()">
          {{budgetReportLblText.exportToPDFLbl}}
          <kendo-loader *ngIf="loadingPDF"></kendo-loader>
        </button>
      </div>
    </ng-template>
    <kendo-grid-column *ngFor="let col of budgetReportGridSettings.columnsConfig" [headerClass]="'wrapheader-sample-admin-grid'"
                       [field]="col.field"
                       [title]="col.title"
                       [width]="col._width"
                       [filter]="col.filter"
                       [filterable]="col.filterable"
                       [hidden]="col.hidden"
                       [format]="col.format" media="(min-width: 1025px)">
      <ng-template kendoGridCellTemplate let-filter let-column="column" let-dataItem *ngIf="col.field == 'cost'">
        {{dataItem.cost | currency}}
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field == 'isActive'">
        <kendo-switch [(ngModel)]="dataItem.isActive" [onLabel]="'Yes'" [disabled]="true"
                      [offLabel]="'No'">
        </kendo-switch>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field == 'isReorder'">
        <span *ngIf="dataItem.isReorder == 'Yes'" class="red"> {{dataItem.isReorder}}</span>
        <span *ngIf="dataItem.isReorder == 'No'"> {{dataItem.isReorder}}</span>
      </ng-template>
      <!--<ng-template kendoGridFilterCellTemplate let-filter let-column="column" let-dataItem
                 *ngIf="col.field == 'isActive'">
      <app-grid-dropdown-filter [filter]="filter" [data]="activeList" textField="name" valueField="activeStatus">
      </app-grid-dropdown-filter>
    </ng-template>-->
    </kendo-grid-column>

    <ng-template kendoGridNoRecordsTemplate>
    </ng-template>

  </kendo-grid>
</section>
